import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useClientId } from '@/features/value/hooks/useClientId';
import { AttentionList } from '../components/AttentionList';
import { CompletenessBlock } from '../components/CompletenessBlock';
import { DisabledEnrollmentAction, EnrollmentStrip } from '../components/EnrollmentStrip';

export function DashboardPage() {
  const { t } = useTranslation();
  const gln = useClientId();
  const [selectedBrandId, setSelectedBrandId] = useState('');

  return (
    <div className="space-y-5" data-testid="dashboard-page">
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="text-xl font-bold tracking-tight text-[var(--foreground)]">{t('dashboard.title')}</h1>
          <p className="mt-1 text-sm text-[var(--foreground-muted)]">{t('dashboard.taskSubtitle')}</p>
        </div>
        <DisabledEnrollmentAction label={t('dashboard.enrollment.new')} />
      </header>
      <EnrollmentStrip />
      <CompletenessBlock gln={gln} onBrandChange={setSelectedBrandId} selectedBrandId={selectedBrandId} />
      <AttentionList gln={gln} />
    </div>
  );
}
